import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    "brand.sub": "Video + Audio",
    "nav.history": "History",
    "nav.login": "Log in",
    "nav.signup": "Sign up free",
    "nav.logout": "Log out",

    "hero.badge": "Dual Engine · Video + Audio Merged",
    "hero.h1a": "Download Any Video",
    "hero.h1b": "With",
    "hero.h1c": "Crystal Clear Audio",
    "hero.sub": "Paste a Facebook, YouTube, Instagram or TikTok link below. Fast, high-definition, and the audio is always merged in.",
    "input.placeholder": "Paste video link here…",
    "btn.paste": "Paste",
    "btn.fetch": "Fetch",

    "feat.merged.t": "Audio Merged",
    "feat.merged.d": "Video and audio delivered as one MP4 file.",
    "feat.quality.t": "Pick Quality",
    "feat.quality.d": "1080p, 720p, 480p or audio-only MP3.",
    "feat.safe.t": "Public & Safe",
    "feat.safe.d": "Download public videos from 100+ sites.",

    "disclaimer": "Only public videos can be downloaded. Private, login-required or DRM-protected content is not supported. Please respect each platform's terms and copyright — only download content you have the right to.",

    "prev.detected": "Stream Detected",
    "prev.selectQuality": "Select Quality",
    "prev.audioIncluded": "Original audio track included",
    "prev.downloadVideo": "Download Video + Audio",
    "prev.downloadAudio": "Download MP3 Audio",
    "prev.downloading": "Downloading…",
    "stage.queued": "Starting…",
    "stage.downloading": "Downloading…",
    "stage.processing": "Merging audio…",
    "stage.saving": "Saving file…",
    "label.eta": "ETA",

    "auth.login": "Log In",
    "auth.signup": "Sign Up",
    "auth.fullname": "Full name",
    "auth.email": "you@email.com",
    "auth.password": "Password",
    "auth.create": "Create Account",
    "auth.newHere": "New here? ",
    "auth.createOne": "Create an account",
    "auth.have": "Already have an account? ",
    "auth.loginLink": "Log in",

    "hist.title": "Download History",
    "hist.search": "Search downloads…",
    "hist.clearAll": "Clear all",
    "hist.empty": "No downloads yet.",
    "hist.noMatch": "No matches found.",
    "hist.redownload": "Re-download",
    "hist.delete": "Delete",

    "toast.linkPasted": "Link pasted!",
    "toast.clipboardBlocked": "Clipboard access blocked. Paste manually.",
    "toast.invalidUrl": "Invalid URL format",
    "toast.videoFound": "Video found!",
    "toast.fetchFail": "Could not fetch video",
    "toast.loginToDownload": "Please log in to download",
    "toast.downloadComplete": "Download complete!",
    "toast.downloadFail": "Download failed",
    "toast.removed": "Removed from history",
    "toast.deleteFail": "Could not delete",
    "toast.cleared": "History cleared",
    "toast.clearFail": "Could not clear",
    "toast.welcomeBack": "Welcome back!",
    "toast.accountCreated": "Account created!",
    "toast.redownloading": "Re-downloading…",

    "about.title": "About VidGrab",
    "about.desc": "VidGrab lets you download public videos with merged audio from Facebook, YouTube, Instagram, TikTok and 100+ sites — fast, free and ad-free.",
    "about.builtBy": "App built by",
    "about.rights": "All rights reserved.",
    "dev.by": "Developed by",
    "dev.mobile": "Mobile",
    "dev.email": "Email",

    "chat.title": "VidBot Assistant",
    "chat.subtitle": "AI help · powered by Gemini",
    "chat.greeting": "Hi! 👋 I'm VidBot, your VidGrab helper. Ask me how to download videos, pick quality, add watermarks or go Premium.",
    "chat.placeholder": "Ask me anything…",
    "chat.error": "Sorry, something went wrong. Please try again.",
    "chat.sug1": "How do I download a video?",
    "chat.sug2": "What does Premium include?",
    "chat.sug3": "How do I download only audio (MP3)?",

    "nav.premium": "Premium",
    "nav.admin": "Admin",
    "usage.downloadsLeft": "free downloads left today",
    "usage.unlimited": "Unlimited downloads",
    "usage.premiumActive": "Premium active",
    "upgrade.title": "Go Premium",
    "upgrade.subtitle": "Unlimited downloads, best quality, no ads.",
    "upgrade.plans": "Plans",
    "upgrade.donate": "Donate",
    "upgrade.cta": "Upgrade to Premium",
    "upgrade.comingSoon": "Payments launching soon — stay tuned!",
    "plan.free": "Free",
    "plan.premium": "Premium",
    "plan.forever": "Free forever",
    "plan.month": "month",
    "plan.popular": "Popular",
    "plan.cancel": "Cancel anytime",
    "donate.desc": "Love VidGrab? Support development and keep it free & ad-light for everyone.",
    "toast.limitReached": "Daily free limit reached. Upgrade for unlimited downloads!",
    "pricing.title": "Simple, honest pricing",
    "pricing.subtitle": "Start free. Upgrade when you need more.",
    "pricing.cta": "View plans",
    "wm.title": "Add my logo / watermark",
    "wm.placeholder": "Type your name or brand (e.g. @mychannel)",
    "wm.hint": "Your text is burned onto the video automatically during download.",
    "wm.topLeft": "Top Left",
    "wm.topRight": "Top Right",
    "wm.bottomLeft": "Bottom Left",
    "wm.bottomRight": "Bottom Right",
    "wm.center": "Center",
    "wm.lockTitle": "Clean & custom watermark is a Premium feature",
    "wm.lockDesc": "Free downloads carry a small vidgurd.com mark. Upgrade for watermark-free + your own logo.",
    "wm.text": "Text",
    "wm.logo": "Logo",
    "wm.color": "Color",
    "wm.size": "Size",
    "wm.opacity": "Opacity",
    "wm.small": "Small",
    "wm.medium": "Medium",
    "wm.large": "Large",
    "wm.uploadLogo": "Upload your logo (PNG/JPG)",
    "wm.logoReady": "Logo added — tap to change",
    "wm.logoTooLarge": "Logo too large (max 3MB)",
    "feat.free1": "3 downloads per day",
    "feat.free2": "Up to 720p quality",
    "feat.free3": "Video + audio merged",
    "feat.free4": "MP3 audio extraction",
    "feat.prem1": "Unlimited downloads",
    "feat.prem2": "Up to 1080p / best quality",
    "feat.prem3": "No ads",
    "feat.prem4": "Priority download speed",
    "feat.prem5": "Full download history",
    "admin.title": "Admin Dashboard",
    "admin.subtitle": "VidGrab Control Center",
    "admin.back": "Back to app",
    "admin.totalUsers": "Total Users",
    "admin.totalDownloads": "Total Downloads",
    "admin.premiumUsers": "Premium Users",
    "admin.downloadsToday": "Downloads Today",
    "admin.dlChart": "Downloads · Last 14 days",
    "admin.suChart": "New Signups · Last 14 days",
    "admin.byPlatform": "Downloads by Platform",
    "admin.byQuality": "Downloads by Quality",
    "admin.noData": "No data yet",
    "admin.users": "Users",
    "admin.colUser": "User",
    "admin.colDownloads": "Downloads",
    "admin.colJoined": "Joined",
    "admin.colStatus": "Status",
    "admin.colAction": "Action",
    "admin.roleAdmin": "Admin",
    "admin.premium": "Premium",
    "admin.free": "Free",
    "admin.grant": "Grant Premium",
    "admin.remove": "Remove Premium",
    "admin.recent": "Recent Downloads",
    "admin.noDownloads": "No downloads yet",
    "admin.loadErr": "Could not load admin data",
    "admin.granted": "Premium granted (30 days)",
    "admin.premRemoved": "Premium removed",
    "admin.actionFail": "Action failed",
  },
  hi: {    "brand.sub": "वीडियो + ऑडियो",
    "nav.history": "हिस्ट्री",
    "nav.login": "लॉग इन",
    "nav.signup": "फ्री साइन अप",
    "nav.logout": "लॉग आउट",

    "hero.badge": "डुअल इंजन · वीडियो + ऑडियो मर्ज्ड",
    "hero.h1a": "कोई भी वीडियो डाउनलोड करें",
    "hero.h1b": "साथ में",
    "hero.h1c": "क्रिस्टल क्लियर ऑडियो",
    "hero.sub": "नीचे Facebook, YouTube, Instagram या TikTok लिंक पेस्ट करें। तेज़, हाई-डेफिनिशन, और ऑडियो हमेशा साथ में मर्ज रहता है।",
    "input.placeholder": "यहाँ वीडियो लिंक पेस्ट करें…",
    "btn.paste": "पेस्ट",
    "btn.fetch": "फेच करें",

    "feat.merged.t": "ऑडियो मर्ज्ड",
    "feat.merged.d": "वीडियो और ऑडियो एक ही MP4 फाइल में मिलता है।",
    "feat.quality.t": "क्वालिटी चुनें",
    "feat.quality.d": "1080p, 720p, 480p या सिर्फ-ऑडियो MP3।",
    "feat.safe.t": "पब्लिक और सुरक्षित",
    "feat.safe.d": "100+ साइटों से सार्वजनिक वीडियो डाउनलोड करें।",

    "disclaimer": "सिर्फ सार्वजनिक (public) वीडियो ही डाउनलोड हो सकते हैं। प्राइवेट, लॉगिन-ज़रूरी या DRM-सुरक्षित कंटेंट समर्थित नहीं है। कृपया हर प्लेटफॉर्म की शर्तों और कॉपीराइट का सम्मान करें — केवल वही कंटेंट डाउनलोड करें जिसका आपको अधिकार हो।",

    "prev.detected": "स्ट्रीम मिली",
    "prev.selectQuality": "क्वालिटी चुनें",
    "prev.audioIncluded": "मूल ऑडियो ट्रैक शामिल है",
    "prev.downloadVideo": "वीडियो + ऑडियो डाउनलोड करें",
    "prev.downloadAudio": "MP3 ऑडियो डाउनलोड करें",
    "prev.downloading": "डाउनलोड हो रहा है…",
    "stage.queued": "शुरू हो रहा है…",
    "stage.downloading": "डाउनलोड हो रहा है…",
    "stage.processing": "ऑडियो मर्ज हो रहा है…",
    "stage.saving": "फाइल सेव हो रही है…",
    "label.eta": "बाकी समय",

    "auth.login": "लॉग इन",
    "auth.signup": "साइन अप",
    "auth.fullname": "पूरा नाम",
    "auth.email": "you@email.com",
    "auth.password": "पासवर्ड",
    "auth.create": "अकाउंट बनाएँ",
    "auth.newHere": "नए हैं? ",
    "auth.createOne": "अकाउंट बनाएँ",
    "auth.have": "पहले से अकाउंट है? ",
    "auth.loginLink": "लॉग इन करें",

    "hist.title": "डाउनलोड हिस्ट्री",
    "hist.search": "डाउनलोड खोजें…",
    "hist.clearAll": "सब मिटाएँ",
    "hist.empty": "अभी कोई डाउनलोड नहीं।",
    "hist.noMatch": "कोई मेल नहीं मिला।",
    "hist.redownload": "फिर डाउनलोड",
    "hist.delete": "हटाएँ",

    "toast.linkPasted": "लिंक पेस्ट हुआ!",
    "toast.clipboardBlocked": "क्लिपबोर्ड एक्सेस बंद है। मैन्युअली पेस्ट करें।",
    "toast.invalidUrl": "गलत URL फॉर्मेट",
    "toast.videoFound": "वीडियो मिल गया!",
    "toast.fetchFail": "वीडियो फेच नहीं हो सका",
    "toast.loginToDownload": "डाउनलोड के लिए लॉग इन करें",
    "toast.downloadComplete": "डाउनलोड पूरा हुआ!",
    "toast.downloadFail": "डाउनलोड विफल",
    "toast.removed": "हिस्ट्री से हटाया गया",
    "toast.deleteFail": "हटाया नहीं जा सका",
    "toast.cleared": "हिस्ट्री साफ़ हुई",
    "toast.clearFail": "साफ़ नहीं हो सका",
    "toast.welcomeBack": "वापसी पर स्वागत है!",
    "toast.accountCreated": "अकाउंट बन गया!",
    "toast.redownloading": "फिर डाउनलोड हो रहा है…",

    "about.title": "VidGrab के बारे में",
    "about.desc": "VidGrab से आप Facebook, YouTube, Instagram, TikTok और 100+ साइटों के सार्वजनिक वीडियो ऑडियो सहित डाउनलोड कर सकते हैं — तेज़, मुफ्त और बिना विज्ञापन।",
    "about.builtBy": "ऐप बनाया",
    "about.rights": "सर्वाधिकार सुरक्षित।",
    "dev.by": "डेवलप किया",
    "dev.mobile": "मोबाइल",
    "dev.email": "ईमेल",

    "chat.title": "VidBot सहायक",
    "chat.subtitle": "AI मदद · Gemini द्वारा",
    "chat.greeting": "नमस्ते! 👋 मैं VidBot हूँ, आपका VidGrab हेल्पर। मुझसे पूछें कि वीडियो कैसे डाउनलोड करें, क्वालिटी चुनें, वॉटरमार्क लगाएं या प्रीमियम लें।",
    "chat.placeholder": "कुछ भी पूछें…",
    "chat.error": "माफ़ करें, कुछ गड़बड़ हो गई। कृपया फिर कोशिश करें।",
    "chat.sug1": "वीडियो कैसे डाउनलोड करूँ?",
    "chat.sug2": "प्रीमियम में क्या मिलता है?",
    "chat.sug3": "सिर्फ ऑडियो (MP3) कैसे डाउनलोड करूँ?",

    "nav.premium": "प्रीमियम",
    "nav.admin": "एडमिन",
    "usage.downloadsLeft": "फ्री डाउनलोड आज बाकी",
    "usage.unlimited": "अनलिमिटेड डाउनलोड",
    "usage.premiumActive": "प्रीमियम चालू",
    "upgrade.title": "प्रीमियम लें",
    "upgrade.subtitle": "अनलिमिटेड डाउनलोड, बेस्ट क्वालिटी, कोई ऐड नहीं।",
    "upgrade.plans": "प्लान",
    "upgrade.donate": "डोनेट",
    "upgrade.cta": "प्रीमियम में अपग्रेड करें",
    "upgrade.comingSoon": "पेमेंट जल्द आ रहा है — बने रहें!",
    "plan.free": "फ्री",
    "plan.premium": "प्रीमियम",
    "plan.forever": "हमेशा फ्री",
    "plan.month": "माह",
    "plan.popular": "लोकप्रिय",
    "plan.cancel": "कभी भी रद्द करें",
    "donate.desc": "VidGrab पसंद है? डेवलपमेंट को सपोर्ट करें और इसे सबके लिए फ्री बनाए रखें।",
    "toast.limitReached": "आज की फ्री लिमिट पूरी हुई। अनलिमिटेड के लिए अपग्रेड करें!",
    "pricing.title": "आसान, ईमानदार कीमत",
    "pricing.subtitle": "फ्री शुरू करें। ज़रूरत पर अपग्रेड करें।",
    "pricing.cta": "प्लान देखें",
    "wm.title": "मेरा लोगो / वॉटरमार्क जोड़ें",
    "wm.placeholder": "अपना नाम या ब्रांड लिखें (जैसे @mychannel)",
    "wm.hint": "आपका टेक्स्ट डाउनलोड के समय अपने-आप वीडियो पर जुड़ जाता है।",
    "wm.topLeft": "ऊपर बाएँ",
    "wm.topRight": "ऊपर दाएँ",
    "wm.bottomLeft": "नीचे बाएँ",
    "wm.bottomRight": "नीचे दाएँ",
    "wm.center": "बीच में",
    "wm.lockTitle": "साफ़ और कस्टम वॉटरमार्क — Premium फीचर",
    "wm.lockDesc": "फ्री डाउनलोड पर छोटा vidgurd.com मार्क रहता है। Premium लें — बिना वॉटरमार्क + अपना लोगो।",
    "wm.text": "टेक्स्ट",
    "wm.logo": "लोगो",
    "wm.color": "रंग",
    "wm.size": "साइज़",
    "wm.opacity": "पारदर्शिता",
    "wm.small": "छोटा",
    "wm.medium": "मध्यम",
    "wm.large": "बड़ा",
    "wm.uploadLogo": "अपना लोगो अपलोड करें (PNG/JPG)",
    "wm.logoReady": "लोगो जुड़ा — बदलने के लिए टैप करें",
    "wm.logoTooLarge": "लोगो बहुत बड़ा है (अधिकतम 3MB)",
    "feat.free1": "रोज़ 3 डाउनलोड",
    "feat.free2": "720p तक क्वालिटी",
    "feat.free3": "वीडियो + ऑडियो मर्ज्ड",
    "feat.free4": "MP3 ऑडियो एक्सट्रैक्शन",
    "feat.prem1": "अनलिमिटेड डाउनलोड",
    "feat.prem2": "1080p / बेस्ट क्वालिटी तक",
    "feat.prem3": "कोई विज्ञापन नहीं",
    "feat.prem4": "प्राथमिकता डाउनलोड स्पीड",
    "feat.prem5": "पूरी डाउनलोड हिस्ट्री",
    "admin.title": "एडमिन डैशबोर्ड",
    "admin.subtitle": "VidGrab कंट्रोल सेंटर",
    "admin.back": "ऐप पर वापस",
    "admin.totalUsers": "कुल यूज़र",
    "admin.totalDownloads": "कुल डाउनलोड",
    "admin.premiumUsers": "प्रीमियम यूज़र",
    "admin.downloadsToday": "आज के डाउनलोड",
    "admin.dlChart": "डाउनलोड · पिछले 14 दिन",
    "admin.suChart": "नए साइनअप · पिछले 14 दिन",
    "admin.byPlatform": "प्लेटफॉर्म अनुसार डाउनलोड",
    "admin.byQuality": "क्वालिटी अनुसार डाउनलोड",
    "admin.noData": "अभी कोई डेटा नहीं",
    "admin.users": "यूज़र",
    "admin.colUser": "यूज़र",
    "admin.colDownloads": "डाउनलोड",
    "admin.colJoined": "जुड़ा",
    "admin.colStatus": "स्थिति",
    "admin.colAction": "एक्शन",
    "admin.roleAdmin": "एडमिन",
    "admin.premium": "प्रीमियम",
    "admin.free": "फ्री",
    "admin.grant": "प्रीमियम दें",
    "admin.remove": "प्रीमियम हटाएँ",
    "admin.recent": "हाल के डाउनलोड",
    "admin.noDownloads": "अभी कोई डाउनलोड नहीं",
    "admin.loadErr": "एडमिन डेटा लोड नहीं हो सका",
    "admin.granted": "प्रीमियम दिया गया (30 दिन)",
    "admin.premRemoved": "प्रीमियम हटाया गया",
    "admin.actionFail": "एक्शन विफल",
  },
};

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("vg_lang") || "en");
  const setLang = useCallback((l) => {
    localStorage.setItem("vg_lang", l);
    setLangState(l);
  }, []);
  const toggle = useCallback(() => setLang(lang === "en" ? "hi" : "en"), [lang, setLang]);
  const t = useCallback(
    (key) => (translations[lang] && translations[lang][key]) ?? translations.en[key] ?? key,
    [lang]
  );
  return <LangContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LangContext.Provider>;
};
